import { render, staticRenderFns } from "./PsychometricReports.vue?vue&type=template&id=03f98606&"
import script from "./PsychometricReports.vue?vue&type=script&lang=js&"
export * from "./PsychometricReports.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/psychometric-reports.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports